import { Box, Chip, Typography } from '@mui/material'
import SegmentMiniRulesWrapper from './segmentMiniRules'

const SegmentHeader = ({
    route,
    departureDate,
    flightIndex,
    arrivesNextDayCallout,
    isConfirmationPage = false,
    pnr = ''
}: {
    route: string
    departureDate: string
    flightIndex: number
    arrivesNextDayCallout: string
    isConfirmationPage?: boolean
    pnr?: string
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, ml: 0.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography sx={{ fontWeight: 600, fontSize: 16 }}>{route}</Typography>
                <Typography sx={{ color: 'textColors.disabled', fontSize: 16, fontWeight: 500 }}>
                    {departureDate}
                </Typography>
                {arrivesNextDayCallout && (
                    <Chip
                        label={arrivesNextDayCallout}
                        sx={{
                            fontSize: 8,
                            fontWeight: 500,
                            height: 16
                        }}
                        variant="outlined"
                        onClick={() => {}}
                        clickable={false}
                    />
                )}
            </Box>
            {!isConfirmationPage && (
                <SegmentMiniRulesWrapper flightIndex={flightIndex} isConfirmationPage={isConfirmationPage} />
            )}
            {isConfirmationPage && pnr ? <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{pnr}</Typography> : ''}
        </Box>
    )
}

export default SegmentHeader
